import { render, staticRenderFns } from "./ExportPageEdgeTab.vue?vue&type=template&id=333e6664&scoped=true"
import script from "./ExportPageEdgeTab.vue?vue&type=script&lang=js"
export * from "./ExportPageEdgeTab.vue?vue&type=script&lang=js"
import style0 from "./ExportPageEdgeTab.vue?vue&type=style&index=0&id=333e6664&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333e6664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333e6664')) {
      api.createRecord('333e6664', component.options)
    } else {
      api.reload('333e6664', component.options)
    }
    module.hot.accept("./ExportPageEdgeTab.vue?vue&type=template&id=333e6664&scoped=true", function () {
      api.rerender('333e6664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/ExportPageEdgeTab.vue"
export default component.exports